import * as textConstants from '../text/constants';

export const { SIZES, APPEARANCES, TYPES, ALIGN } = textConstants;

const { mediumEmphasis, lowEmphasis, accent, cta, danger, success, white } = APPEARANCES;

export const HEADING_APPEARANCES = {
  default: 'default',
  mediumEmphasis,
  lowEmphasis,
  accent,
  cta,
  danger,
  success,
  white,
};

export const HEADING_TYPES = {
  heading_0: 'heading-0',
  heading_1: 'heading-1',
  heading_2: 'heading-2',
  heading_3: 'heading-3',
  heading_4: 'heading-4',
  heading_5: 'heading-5',
  heading_6: 'heading-6',
};
